import { render } from "./ConfigurationPanelTabContent.vue?vue&type=template&id=fad6ec98&scoped=true"
import script from "./ConfigurationPanelTabContent.vue?vue&type=script&lang=ts"
export * from "./ConfigurationPanelTabContent.vue?vue&type=script&lang=ts"

import "./ConfigurationPanelTabContent.vue?vue&type=style&index=0&id=fad6ec98&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-fad6ec98"

export default script